import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Rss, Globe, PinIcon, Instagram, Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t, isRTL } = useLanguage();

  return (
    <footer>
      {/* Main Footer */}
      <div className="bg-slate-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* About Us */}
            <div>
              <h3 className="text-xl font-bold mb-4">
                {t.footer.aboutUs.split(' ')[0]} <span className="text-cyan-400">{t.footer.aboutUs.split(' ').slice(1).join(' ')}</span>
              </h3>
              <p className="text-slate-300 text-sm leading-relaxed">
                {isRTL ? companyInfo.descriptionArabic : companyInfo.description}
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h3 className="text-xl font-bold mb-4">
                {isRTL ? t.footer.navigation : 'NAVIGATI'}<span className="text-cyan-400">{isRTL ? '' : 'ON'}</span>
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">
                    {t.nav.about}
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">
                    {t.nav.services}
                  </Link>
                </li>
                <li>
                  <Link to="/events" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">
                    {t.nav.events}
                  </Link>
                </li>
                <li>
                  <Link to="/cmes" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">
                    {t.nav.cme}
                  </Link>
                </li>
                <li>
                  <Link to="/clients" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">
                    {t.nav.clients}
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">
                    {t.nav.contact}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Twitter */}
            <div>
              <h3 className="text-xl font-bold mb-4">
                TWITTER
              </h3>
              <p className="text-slate-400 text-sm italic">{isRTL ? 'جاري التحميل...' : 'Loading...'}</p>
            </div>

            {/* Contact Details */}
            <div>
              <h3 className="text-xl font-bold mb-4">
                {isRTL ? t.footer.contactDetails : 'CONTACT'} <span className="text-cyan-400">{isRTL ? '' : 'DETAILS'}</span>
              </h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start gap-2">
                  <Phone size={16} className="text-cyan-400 mt-1 flex-shrink-0" />
                  <span className="text-slate-300" dir="ltr">{companyInfo.phone}</span>
                </li>
                <li className="flex items-start gap-2">
                  <Mail size={16} className="text-cyan-400 mt-1 flex-shrink-0" />
                  <span className="text-slate-300" dir="ltr">{companyInfo.email}</span>
                </li>
                <li className="flex items-start gap-2">
                  <MapPin size={16} className="text-cyan-400 mt-1 flex-shrink-0" />
                  <span className="text-slate-300">{isRTL ? companyInfo.addressArabic : companyInfo.address}</span>
                </li>
              </ul>

              {/* Social Icons */}
              <div className="flex gap-2 mt-4">
                <a href="#" className="w-8 h-8 border border-white flex items-center justify-center hover:bg-cyan-400 hover:border-cyan-400 transition-colors">
                  <Facebook size={16} />
                </a>
                <a href="#" className="w-8 h-8 border border-white flex items-center justify-center hover:bg-cyan-400 hover:border-cyan-400 transition-colors">
                  <Rss size={16} />
                </a>
                <a href="#" className="w-8 h-8 border border-white flex items-center justify-center hover:bg-cyan-400 hover:border-cyan-400 transition-colors">
                  <Globe size={16} />
                </a>
                <a href="#" className="w-8 h-8 border border-white flex items-center justify-center hover:bg-cyan-400 hover:border-cyan-400 transition-colors">
                  <PinIcon size={16} />
                </a>
                <a href="#" className="w-8 h-8 border border-white flex items-center justify-center hover:bg-cyan-400 hover:border-cyan-400 transition-colors">
                  <Instagram size={16} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-cyan-500 text-white py-3">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center text-sm">
            <p>{t.footer.copyright}</p>
            <button className="bg-slate-800 hover:bg-slate-900 w-8 h-8 flex items-center justify-center transition-colors">
              <span className="text-lg">⌂</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;